import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

const customFetch: typeof fetch = async (uri, options) => {
  const response = await fetch(uri, options);

  if (response.status === 401 || response.status === 409) {
    const isEmbed = window.location.pathname.startsWith('/embed/');

    localStorage.removeItem('authData');

    if (isEmbed) {
      window.dispatchEvent(new CustomEvent('embed-session-expired'));
    } else {
      const message =
        response.status === 401
          ? 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.'
          : 'Se ha iniciado sesión en otro dispositivo. Por favor, inicia sesión nuevamente.';
      localStorage.setItem('sessionMessage', message);
      window.location.href = '/login';
    }

    // Retornar una respuesta vacía para evitar que Apollo procese el body
    return new Response(JSON.stringify({ data: null }), {
      status: 200,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  return response;
};

const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL;

if (!GRAPHQL_URL) {
  // Surface the misconfiguration loudly: without an env file the app would
  // silently hit an undefined URL and every request would fail at fetch.
  // eslint-disable-next-line no-console
  console.error(
    'REACT_APP_GRAPHQL_URL is not defined. ' +
      'Make sure you are running the app via one of the scripts in package.json ' +
      '(npm start / npm run build:qa / npm run build:staging) so that env-cmd ' +
      'loads the right file from environments/.'
  );
}

const httpLink = new HttpLink({
  uri: GRAPHQL_URL,
  fetch: customFetch,
});

const authLink = setContext((_, { headers }) => {
  // Obtener el token del localStorage
  const authData = localStorage.getItem('authData');
  let token = null;

  if (authData) {
    try {
      const parsedData = JSON.parse(authData);
      token = parsedData.token;
    } catch (err) {
      console.error('Error parsing auth data:', err);
    }
  }

  // Retornar los headers con el token si existe
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

export const client = new ApolloClient({
  link: ApolloLink.from([authLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
    },
    query: {
      fetchPolicy: 'network-only',
    },
  },
});
